/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./tabsComponent.css";

export function Tabs({ tabs, activeTab, onTabSelection }) {
  return (
    <div>
      <ul className="tab-list ">
        {tabs.map((tab) => (
          <li
            key={tab.key}
            className={activeTab === tab.key ? "tab-item active" : "tab-item"}
            onClick={() => {
              onTabSelection(tab.key);
            }}
            onKeyDown={
              (event) => event.key === "Enter" && onTabSelection(tab.key)
            }
          >
            {tab.display}
          </li>
        ))}
      </ul>
    </div>
  );
}
